<!-- Attachments2 Modal  -->

@if (documents) {
  <p-dialog
    [visible]="attachmentsModal()"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [breakpoints]="{ '767px': '100vw' }"
    [style]="{ width: '920px' }"
    styleClass="no-header-modal"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div
        class="px-3 py-2 md:py-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-sm">
          {{ 'ADMIN.DOCUMENT.ATTACHMENTS' | translate }} -
          <strong>{{ documents.length }}</strong>
          {{ 'ADMIN.DOCUMENT.UPLOADS' | translate }}
        </h2>
        <div class="flex align-items-center justify-content-end">
          <div class="mr-3">
            <p-button
              label="{{ 'ADMIN.DOCUMENT.UPLOAD_ATTACHMENT' | translate }}"
              icon="fa fa-upload"
              (click)="uploadAttachment()"
              styleClass="text-sm hidden md:inline-block"
            />
            <p-button
              icon="fa fa-upload"
              (click)="uploadAttachment()"
              styleClass="md:hidden"
            />
          </div>
          <div
            class="fa fa-times text-xl text-600 cursor-pointer"
            (click)="closeDialog()"
          ></div>
        </div>
      </div>
      <!-- Header -->
      <!-- Modal Content -->
      <div class="surface-50 text-600 md:flex">
        <!-- Left Side -->
        <div class="md:w-18rem">
          <div class="pt-3 px-3 md:px-4 text-xs font-bold uppercase">
            {{ 'ADMIN.DOCUMENT.BROWSE_FOLDERS' | translate }}
          </div>
          <ul class="list-none p-0 m-0 border-bottom-1 border-300">
            <li
              (click)="setFilterDocumentType()"
              [ngClass]="{
                'bg-blue-50': !activeFilter,
                ' text-primary': !activeFilter,
              }"
              class="cursor-pointer px-3 md:px-4 py-2 flex align-items-center justify-content-between text-sm hover:bg-blue-50 hover:text-primary mt-2"
            >
              <span>{{ 'ADMIN.DOCUMENT.ALL' | translate }}</span>
              @if (documents) {
                <p-badge
                  [value]="documents.length"
                  [styleClass]="activeFilter ? 'surface-600' : ''"
                />
              }
            </li>
            @for (folder of documentTypes; track folder.id) {
              <li
                [ngClass]="{
                  'bg-blue-50': activeFilter && activeFilter?.id === folder?.id,
                  ' text-primary':
                    activeFilter && activeFilter?.id === folder?.id,
                }"
                (click)="setFilterDocumentType(folder.name_primary_language)"
                class="cursor-pointer px-3 md:px-4 py-2 flex align-items-center justify-content-between text-sm hover:bg-blue-50 hover:text-primary mt-2"
              >
                <span>{{ folder.name_primary_language }}</span>
                <p-badge
                  ng
                  [value]="
                    documentsGrouped && documentsGrouped[folder.id]
                      ? documentsGrouped[folder.id].length
                      : 0
                  "
                  [styleClass]="
                    activeFilter && activeFilter?.id === folder?.id
                      ? ''
                      : 'surface-600'
                  "
                />
              </li>
            }
          </ul>
          <p-button
            pRipple
            [label]="'ADMIN.DOCUMENT.CREATE_FOLDER' | translate"
            icon="fa fa-plus-circle"
            styleClass="p-button-text text-sm my-2"
            (click)="addFolder()"
          />
        </div>
        <!-- Left Side -->
        <!-- Right Side -->
        <div class="md:w-8 border-left-1 border-300">
          <div class="p-3 md:p-4">
            @for (folder of filterDocumentType | async; track folder.id) {
              @if (
                documentsGrouped &&
                documentsGrouped[folder.id] &&
                documentsGrouped[folder.id].length > 0
              ) {
                <h5 class="mb-3 font-normal text-sm text-900">
                  {{ folder.name_primary_language }} -
                  <strong>{{ getDocumentCount(folder.id) }}</strong>
                </h5>
                <!-- Attachments -->
                <ul class="list-none mx-0 mb-6 p-0 text-sm">
                  @for (doc of documentsGrouped[folder.id]; track doc.id) {
                    <li
                      class="surface-200 flex justify-content-between border-1 border-400 border-round mt-2"
                    >
                      <div
                        class="flex align-items-center justify-content-between text-600 p-2 md:p-3 w-full"
                      >
                        <a target="_blank" [href]="getURL(doc)">
                          <strong
                            pTooltip="{{ getFileName(doc) }}"
                            tooltipStyleClass="text-xs -mt-3"
                            tooltipPosition="top"
                            class="text-primary w-10rem md:w-17rem lg:w-23rem cursor-pointer white-space-nowrap overflow-hidden text-overflow-ellipsis block"
                            >{{ getFileName(doc) }}
                          </strong></a
                        >
                        <!-- <span>122 KB</span> -->
                      </div>
                      <div class="border-left-1 border-400 flex p-2 md:p-3">
                        <i
                          (click)="onDown(doc)"
                          class="fa fa-download cursor-pointer mr-3"
                          pTooltip="Download"
                          tooltipStyleClass="text-xs -mt-3"
                          tooltipPosition="top"
                        ></i>
                        <i
                          (click)="activateDelete(doc)"
                          class="fa fa-times text-xl cursor-pointer"
                          pTooltip="{{ 'ADMIN.COMMON.DELETE' | translate }} "
                          tooltipStyleClass="text-xs -mt-3"
                          tooltipPosition="top"
                        ></i>
                      </div>
                    </li>
                  }
                </ul>
                <!-- Attachments -->
              }
            }
          </div>
        </div>
        <!-- Right Side -->
      </div>
      <!-- Modal Content -->
    </ng-template>
  </p-dialog>
  <!-- Attachments2 Modal -->
  <!-- Delete Attachment Modal  -->
  <p-dialog
    [visible]="deleteAttachmentModal"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [breakpoints]="{ '767px': '100vw' }"
    [style]="{ width: '470px' }"
    styleClass="no-header-modal"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Content -->
      <div class="relative text-center px-5 pt-5 pb-3">
        <div
          class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="deleteAttachmentModal = false"
        ></div>
        <i class="fa fa-exclamation-triangle p-error text-7xl mt-5"></i>
        <h4 class="text-lg mb-2 my-5">
          {{ 'ADMIN.DOCUMENT.SURE' | translate }}
        </h4>
        <p class="text-600 mb-3 text-sm">
          {{ 'ADMIN.DOCUMENT.IF_DELETE' | translate }}
        </p>
      </div>
      <!-- Content -->
      <!-- Modal Footer -->
      <div class="lg:px-4 px-2 py-3 border-top-1 border-300 surface-0">
        <div class="flex align-items-center justify-content-between">
          <div class="w-4">
            <p-button
              label="{{ 'ADMIN.COMMON.CANCEL' | translate }}"
              type="button"
              styleClass="p-button-link text-sm"
              (click)="deleteAttachmentModal = false"
            />
          </div>
          <div class="w-8 text-right">
            <p-button
              label="{{ 'ADMIN.DOCUMENT.CONTINUE' | translate }}"
              type="button"
              [loading]="isSubmitting"
              styleClass="text-sm p-button-danger"
              (click)="deleteDocument()"
            />
          </div>
        </div>
      </div>
      <!-- Modal Footer -->
    </ng-template>
  </p-dialog>
  <!-- Delete Attachment Modal -->
}
